
export default class language{
	static getStringByKey(key){
		var lan = (navigator.language || navigator.browserLanguage).toLowerCase();
		if( lan=="zh-cn" ){
			if( key=="Waitting" ){
				return "请稍候...";
			}
			else if( key=="Loging" ){
				return "正在登录...";
			}
			else if( key=="Loging_failed" ){
				return "登录失败...";
			}
			else if( key=="Ok" ){
				return "确定";
			}
			else if( key=="Cancel" ){
				return "取消";
			}
			else if( key=="Are you sure quit" ){
				return "确定取消控制吗？";
			}
			else if( key=="Watting frient accept" ){
				return "正在等待对方接受控制";
			}
			else if( key=="Friend ask for request control" ){
				return "好友向您发起了控制请求";
			}
			else if( key=="Friend has cancel control" ){
				return "好友取消了控制";
			}
			else if( key=="Friend has end control" ){
				return "好友结束了控制";
			}
			else if( key=="You has cancel control" ){
				return "你已取消了控制";
			}
			else if( key=="Link is invalided" ){
				return "链接已失效";
			}
			else if( key=="Apply control" ){
				return "申请控制";
			}
			else if( key=="End control" ){
				return "结束控制";
			}
			else if( key=="Please click Apply control to start" ){
				return "请点击申请控制开始";
			}
			else if( key == "Wave"){
				return "我的模式";
			}
			else if( key == "Strong"){
				return "一键暴走";
			}
			else if( key == "Single"){
				return "单曲循环";
			}
			else if( key == "Sequence"){
				return "顺序播放";
			}
			else if( key == "Random"){
				return "随机播放";
			}
			else if( key == "Playing wave:"){
				return "正在播放：";
			}
		}
		else{
			if( key=="Waitting" ){ 
				return "Please wait...";
			}
			if( key=="Loging" ){
				return "loging...";
			}
			else if( key=="Loging_failed" ){
				return "Loging failed...";
			}
			else if( key=="Ok" ){
				return "Ok";
			}
			else if( key=="Cancel" ){
				return "Cancel";
			}
			else if( key=="Are you sure quit" ){
				return "Are you sure quit？";
			}
			else if( key=="Watting frient accept" ){
				return "Watting frient accept to control";
			}
			else if( key=="Friend ask for request control" ){
				return "Friend ask for request control";
			}
			else if( key=="Friend has cancel control" ){
				return "Friend has cancel control";
			}
			else if( key=="Friend has end control" ){
				return "Friend has end control";
			}
			else if( key=="You has cancel control" ){
				return "You has cancel control";
			}
			else if( key=="Link is invalided" ){
				return "Link is invalided";
			}
			else if( key=="Apply control" ){
				return "Apply control";
			}
			else if( key=="End control" ){
				return "End control";
			}
			else if( key=="Please click Apply control to start" ){
				return "Please click Apply control to start";
			}
			else if( key == "Wave"){
				return "Wave";
			}
			else if( key == "Strong"){
				return "Strong";
			}
			else if( key == "Single"){
				return "Single";
			}
			else if( key == "Sequence"){
				return "Sequence";
			}
			else if( key == "Random"){
				return "Random";
			}
			else if( key == "Playing wave:"){
				return "Playing wave:";
			}
		}
	}
}